import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { ReleaseNote } from 'types/releaseNotes';

export function useReleaseNotes({ enabled = true }: { enabled?: boolean } = {}) {
  const {
    data: releaseNotes = [],
    isLoading,
    error,
  } = useQuery<ReleaseNote[]>({
    queryKey: ['releaseNotes'],
    queryFn: () => get('releaseNotes') as Promise<ReleaseNote[]>,
    enabled,
  });

  return {
    releaseNotes,
    isLoading,
    error: error instanceof Error ? error.message : error ? 'Unknown error' : null,
  };
}
